import axios from "axios";
import { useState, useEffect, useRef } from "react";
import { styled } from "styled-components";
import { Carousel, Tooltip } from "antd";
import dayjs from "dayjs";
import { keyframes } from "styled-components";

export async function getReview() {
  const response = await axios.get("/homepageReview?vetIdx=12"); // vetIdx 수정
  return response.data;
}

function Review() {
  const [windowWidth, setWindowWidth] = useState();

  const [dataList, setDataList] = useState([]);
  const [slidesToShow, setSlidesToShow] = useState(3); // 캐러셀 초기 슬라이더 갯수 설정

  const [animate, setAnimate] = useState(false);
  const componentRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      let review_data = [
        {
            "idx": 51,
            "vetIdx": 12,
            "nickname": "elena96",
            "imgUrl": null,
            "content": "토요일에 강원도여행갔다가 개물림사고로 내원했습니다. 정신없는 와중에 수의사쌤이 너무 상세히 설명해주셔서 감사했어요. 그리고 며칠뒤 저희지역 다른 병원 방문했을때 궁금한점들도 전화로 문의드렸는데 휴무신데도 또 너무 자세하게 섷명해주셔서 넘 감사했습니다. 저희 지역에도 이런 수의사쌤과 이런 병원이 있었으면 좋겠다고 생각했어요. 너무너무 추천합니다!!",
            "regDate": "2024-05-11"
        },
        {
            "idx": 57,
            "vetIdx": 12,
            "nickname": "hjk070615",
            "imgUrl": null,
            "content": "강릉동물병원 15년다녀도 도덕성에 인재였는데\n유강연선생님은 상담과 제 이야기?하소연까지 들어주시고 마음 달래주셔서 너무 감사합니다\n아이 사랑과 친절함에 감동 받고 내려왔어요\n건강하세요",
            "regDate": "2023-12-27"
        },
        {
            "idx": 56,
            "vetIdx": 12,
            "nickname": "sktkfkd",
            "imgUrl": null,
            "content": "우리 첫째 심장때문에 가는곳이에요.선생님들 실력좋으시고 꼼꼼하세요.오래오래근무셨으면좋겠어요.\n과잉없이 친절하십니다",
            "regDate": "2024-02-16"
        },
        {
            "idx": 55,
            "vetIdx": 12,
            "nickname": "cis****",
            "imgUrl": null,
            "content": "링웜의심되어서 갔는데 다행이 경미한 수준이라 소독 스프레이만 받았습니다\n양심진료해주시고 친절하세요\n진료 잘봐주셔서 감사합니다!",
            "regDate": "2024-03-03"
        },
        {
            "idx": 60,
            "vetIdx": 12,
            "nickname": "young soso",
            "imgUrl": null,
            "content": "강아지 앞다리 골절로 인해 최근에 수술했습니다. 관절 부분이라 걷지 못하면 어쩌나 걱정이 많았는데\n다행히 수술 잘 되어서 곧잘 걸어 다니네요.\n오 원장님께서 보호자 입장 헤아려 주시고\n병원비도 배려를 많이 해주셔서 너무도 감사한 마음입니다.\n강원지역 외에도 제천, 단양, 충주 지역에서 한 시간 이내로 갈 수 있는 야간 응급되는 2차 병원이 있다는 게 안심이 되구요.\n직접 방문해 보니 서울 경기지역 2차 병원에 비하면 진료비도 상대적으로는 저렴한 부분이 있습니다\n입원 시에 24시간 수의사 선생님이 상주하고\n저녁시간 면회가 가능한 것도 장점이었구요\n반려동물이 2차 병원을 갈 일이 없으면 제일 좋겠지만\n만약 가야 할 일이 생긴다면 저는 다음에도 믿고\n오형석 원장님께 진료를 받을 생각입니다.",
            "regDate": "2023-09-24"
        },
        {
            "idx": 50,
            "vetIdx": 12,
            "nickname": "나욤630",
            "imgUrl": null,
            "content": "저희 고양이가 계속 구토를 하고 설사를 해서 병원에 내원했어요 ㅠ_ㅠ\n\n병원 도착하자마자 병원이 너무 깔끔했고, 데스크 선생님들도 다 친절하시고 아이를 좋아하시는게 느껴져서 너무 좋았고 마음이 놓였어요!\n\n진료 봐주신 선생님께서 제가 알아듣기 쉽게 설명해주셨고, 꼼꼼하게 아이를 체크해주셔서 믿음이 갔고, 너무 감사했어용\n\n진료 후 처방사료와 지어주신 약 먹고 이제 아이가 아프지 않아서 감사한 마음에 리뷰 남깁니당\n\n저희 애기 아프지 않게 치료해주셔서 감사합니다 8ㅅ8",
            "regDate": "2024-05-17"
        },
        {
            "idx": 61,
            "vetIdx": 12,
            "nickname": "호이잇호잇35",
            "imgUrl": null,
            "content": "애기가 아파 펑펑울며 찾아갔는데\n친절하고 잘 설명해주신 덕분에 한시름놓았고\n아픈곳 잘 캐치해서 잘 수술해주셔서\n애기가 활력이 돌아왔어요\n먼거리라 전화 자주드렸는데\n전화받으시는 모든분들이 친절하셔서 너무 감사했습니다 리아 치료잘해주셔서 감사합니다👍🏻",
            "regDate": "2023-09-05"
        },
        {
            "idx": 54,
            "vetIdx": 12,
            "nickname": "Eloiseeloise",
            "imgUrl": null,
            "content": "일요일 저녁에 아이 응급상황이라 급하게 가게됐어요.\n여자선생님께 진료 받았는데 친절하시고,\n설명도 상세히 잘 해주셔요.\n다른곳보다 진료비, 입원비 다 비싸긴하지만 선생님이 좋으셔서 추천합니다..!",
            "regDate": "2024-03-25"
        },
        {
            "idx": 53,
            "vetIdx": 12,
            "nickname": "elena96",
            "imgUrl": null,
            "content": "토요일에 강원도여행갔다가 개물림사고로 내원했습니다. 정신없는 와중에 수의사쌤이 너무 상세히 설명해주셔서 감사했어요. 그리고 며칠뒤 저희지역 다른 병원 방문했을때 궁금한점들도 전화로 문의드렸는데 휴무신데도 또 너무 자세하게 섷명해주셔서 넘 감사했습니다. 저희 지역에도 이런 수의사쌤과 이런 병원이 있었으면 좋겠다고 생각했어요. 너무너무 추천합니다!!",
            "regDate": "2024-05-11"
        },
        {
            "idx": 52,
            "vetIdx": 12,
            "nickname": "나욤630",
            "imgUrl": null,
            "content": "저희 고양이가 계속 구토를 하고 설사를 해서 병원에 내원했어요 ㅠ_ㅠ\n\n병원 도착하자마자 병원이 너무 깔끔했고, 데스크 선생님들도 다 친절하시고 아이를 좋아하시는게 느껴져서 너무 좋았고 마음이 놓였어요!\n\n진료 봐주신 선생님께서 제가 알아듣기 쉽게 설명해주셨고, 꼼꼼하게 아이를 체크해주셔서 믿음이 갔고, 너무 감사했어용\n\n진료 후 처방사료와 지어주신 약 먹고 이제 아이가 아프지 않아서 감사한 마음에 리뷰 남깁니당\n\n저희 애기 아프지 않게 치료해주셔서 감사합니다 8ㅅ8",
            "regDate": "2024-05-17"
        },
        {
            "idx": 59,
            "vetIdx": 12,
            "nickname": "새우우동",
            "imgUrl": null,
            "content": "강아지가 갑자기 다리를 절어서 급하게 다녀왔어요.. 1층에 계신 직원분도 친절하시고 수의사 선생님도 다정하셨어요🥹 뭐에 물렸나하고 엄청 걱정했는데 차분하게 진료해주셔서 정말 감사했습니다..!",
            "regDate": "2023-10-19"
        },
        {
            "idx": 58,
            "vetIdx": 12,
            "nickname": "1004dbfla8",
            "imgUrl": null,
            "content": "17살 노견을 키우고있습니다!\n저희 반려견 여기병원아니였으면 정말 ㅠ ㅠ 더 살고 같은시간을 보냈을 수 도있었는데 병원들 말만 듣고 마음의준비를하고있었습니다.. 노견이라 자연스러운현상이다, 오늘내일중으로 위급상황이 발생할수있는데 일단 급한치료는 가능하다 등 이런 극단적이고 희망적이지않은 진료를 하고, 결국 여러병원 돌아다니다 마지막 병원에서 원주에있는 병원과연결해줄테니 한번 바로 가보셔라해서 희망을 안고 바로 차타고 갔습니다 수의사님께서는 부정적인말 한마디없이 차근차근 설명해주셨고 왜 이런증상이 나타났는지 설명해주셨습니다 .. 걷지도못하고 소변도 누워서 싸고 얼굴이 한쪽으로 치우쳐져걷던 반려견이 지금은 약복용하면서 집에서 짖고 뛰어다니고 건강한아기가됐어요 담당수의사님 정말 감사합니다😭",
            "regDate": "2023-10-23"
        }
    ];
      setDataList(review_data);
      // try {
      //   // API 호출
      //   const res = await getReview();
      //   // 데이터 받아오면 상태 업데이트
      //   if (res.result === "ok") {
      //     setDataList(res.data);
      //     console.log(res.data);
      //   } else console.log(res.result);
      // } catch (error) {
      //   console.error("Error fetching review data:", error);
      // }
    };

    fetchData(); // 함수 호출
  }, []); // 빈 배열은 컴포넌트가 마운트될 때 한 번만 실행

  useEffect(() => {
    const handleScroll = () => {
      // 예시: 화면의 중간에 도달했을 때 애니메이션을 실행하려면
      // const midScreen = window.innerHeight * 5.5;
      const componentTop = componentRef.current.getBoundingClientRect().top;

      // console.log('innerHeight : ', window.innerHeight);
      // console.log('scrollY : ', window.scrollY);
      // console.log('midScreen : ', midScreen);
      if (componentTop < window.innerHeight) {
        setAnimate(true);
      }
      // else {
      //   setAnimate(false);
      // }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      // 컴포넌트 언마운트 시 이벤트 리스너 제거
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    setWindowWidth(window.innerWidth);

    const handleResize = () => {
      setWindowWidth(window.innerWidth);

      // 화면 크기에 따라 slidesToShow 값을 동적으로 변경
      if (window.innerWidth < 576) {
        setSlidesToShow(1);
      } else if (window.innerWidth < 768) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(3);
      }
    };

    // 컴포넌트 마운트 시 초기 값 설정
    handleResize();

    // 창 크기가 변경될 때마다 이벤트 리스너 등록
    window.addEventListener("resize", handleResize);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + "...";
  };

  const maskedNickname = (nickname) =>
    nickname.substring(0, 2) + "*".repeat(nickname.length - 2);

  return (
    <>
      <Container>
        <TextWrapper ref={componentRef}>
          <div className={animate ? "animate" : ""}>
            <p style={{ margin: 0 }}>Review</p>
            <h2 style={{ margin: 0, marginBottom: "16px" }}>
              <strong>리/얼/후/기</strong>
            </h2>
          </div>
        </TextWrapper>
        <CarouselContainer>
          <StyledCarousel
            slidesToShow={slidesToShow}
            autoplay={true}
            autoplaySpeed={5000}
            dots={false}
            // dotPosition="bottom"
          >
            {dataList.map((item, index) => (
              <div key={item.idx}>
                <div
                  style={{
                    margin: "5px 20px",
                    boxSizing: "border-box",
                  }}
                >
                  {slidesToShow === 2 ? (
                    <Tooltip
                      title={item.content}
                      overlayStyle={{
                        letterSpacing: "1px",
                        lineHeight: "1.5",
                        maxWidth: "400px",
                      }}
                      overlayInnerStyle={{
                        // backgroundColor: "whitesmoke",
                        // color: "#000",
                        padding: "10px 20px",
                      }}
                    >
                      <div
                        style={{
                          minHeight: "300px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          textAlign: "center",
                          padding: "20px",
                          borderRadius: "20px",
                          boxShadow: "0 4px 8px rgb(0,0,0,0.2)",
                          // border: "1px solid #ccc",
                          // backgroundColor: "#e2edf6",
                        }}
                      >
                        <div>
                          <p className="name">
                            {maskedNickname(item.nickname)}님의 리뷰
                          </p>
                          <p className="content">
                            {dayjs(item.regDate).format("YYYY.MM")}
                          </p>
                          <p className="content">
                            {windowWidth < 576 || windowWidth > 768
                              ? item.content
                              : truncateText(item.content, 100)}
                          </p>
                        </div>
                      </div>
                    </Tooltip>
                  ) : (
                    <div
                      style={{
                        minHeight: "300px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        textAlign: "center",
                        padding: "20px",
                        borderRadius: "20px",
                        boxShadow: "0 4px 8px rgb(0,0,0,0.2)",
                        // border: "1px solid #ccc",
                        // backgroundColor: "#e2edf6",
                      }}
                    >
                      <div>
                        <p className="name">
                          {maskedNickname(item.nickname)}님의 리뷰
                        </p>
                        <p className="content">
                          {dayjs(item.regDate).format("YYYY.MM")}
                        </p>
                        <p className="content">
                          {slidesToShow === 2
                            ? truncateText(item.content, 100)
                            : item.content}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </StyledCarousel>
        </CarouselContainer>
      </Container>
    </>
  );
}

const Container = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%; /* 가로 폭 100%로 설정 */
  padding: 5rem 1rem;
  /* margin: 50px 42px 60px 42px; */
  /* background-color: whitesmoke; */
  & .name {
    font-size: 1.2rem;
    font-weight: 700;
  }
`;

const CarouselContainer = styled.div`
  width: 100%;
`;

const StyledCarousel = styled(Carousel)`
  .slick-dots {
    padding: 0; /* 기존 패딩 초기화 */
    list-style: none; /* 리스트 스타일 제거 */

    li {
      margin-right: 8px; /* 도트 간 여백 조절 */
      button {
        margin-top: 40px; /* 기존 마진 초기화 */
        width: 8px; /* 도트 크기 조절 */
        height: 8px;
        border-radius: 50%; /* 도트를 원 모양으로 만들기 */
      }
    }
  }
`;

const TitleWrapper = styled.div`
  width: 80%;
  height: fit-content;
  @media screen and (max-width: 690px) {
    padding-bottom: 2rem;
  }
  padding-bottom: 4rem;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h2 {
      color: #000048;
      font-size: 3rem;
      margin: 0;
    }
    p {
      color: #000048;
      margin: 5px;
    }
  }
`;

const slideDown = keyframes`
    from {
        transform: translate(0, -50%);
        opacity: 0;
    }
    to {
        transform: translate(0,0);
        opacity: 1;
    }
`;

const TextWrapper = styled.div`
  width: 100%;
  height: 20%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  color: #403631;

  @media screen and (max-width: 500px) {
    justify-content: center;
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h2 {
      font-size: 2.5rem;
      font-weight: normal;
      @media screen and (max-width: 690px) {
        font-size: 2rem;
      }
    }
    p {
      font-weight: bold;
      font-size: 0.9rem;
      opacity: 0.6;
    }
  }

  .animate {
    animation: ${slideDown} 4s ease;
  }
`;

export default Review;
